import { Pinwheel } from "./Pinwheel";

export function CenterHub() {
  return (
    <div
      className="pointer-events-none absolute flex items-center justify-center"
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "16%",
        height: "16%",
        color: "#F28132"
      }}
      role="img"
      aria-label="OpenSesame"
    >
      <Pinwheel className="h-full w-full" />
    </div>
  );
}
